module.exports = __webpack_public_path__ + "img/wholesale7.90f3f7dc.png";